
import { defineComponent } from 'vue'
import { iDimension } from './HierarchyManagement.d'
import { AxiosResponse } from 'axios'
import HierarchyManagementMasterTab from './HierarchyManagementMasterTab/HierarchyManagementMasterTab.vue'
import HierarchyManagementTechnicalTab from './HierarchyManagementTechnicalTab/HierarchyManagementTechnicalTab.vue'
import HierarchyManagementBackupTab from './HierarchyManagementBackupTab/HierarchyManagementBackupTab.vue'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import ProgressSpinner from 'primevue/progressspinner'
import descriptor from './HierarchyManagementDescriptor.json'

export default defineComponent({
    name: 'hierarchy-management',
    components: { ProgressSpinner, HierarchyManagementMasterTab, HierarchyManagementTechnicalTab, HierarchyManagementBackupTab, TabView, TabPanel },
    data() {
        return {
            dimensions: [] as iDimension[],
            loading: false,
            descriptor
        }
    },
    async created() {
        await this.loadDimensions()
    },
    methods: {
        async loadDimensions() {
            this.loading = true
            await this.$http
                .get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `dimensions/getDimensions`)
                .then((response: AxiosResponse<any>) => (this.dimensions = response.data))
                .catch(() => {})
            this.loading = false
        },
        setLoading(value: boolean) {
            this.loading = value
        }
    }
})
